import React from 'react';
import cn from 'clsx';
import { useDeviceType, Button } from '@cian/ui-kit';
import styles from './styles.css';

import { IButton } from 'shared/types/common/offer';
import { ETestIds } from 'shared/constants/testIds';
import { useAuthorized, useCianAuthorized, useIsMortgageRedirectEnabled } from '../../../../hooks/useAuthorized';
import { useIsTinyScreen } from '../../../../hooks/common';

export interface IOfferBtnProps extends IButton {}

export const OfferBtn: React.FC<IOfferBtnProps> = ({
  text,
  theme,
  path,
  authorizationRequired,
  bankName,
  analyticEventKey,
  isMultiOffer,
  place,
}) => {
  const deviceType = useDeviceType();
  const isMortgageRedirectEnabled = useIsMortgageRedirectEnabled();
  const { authorizeAndRedirect } = useAuthorized();
  const { cianAuthorizeAndRedirect } = useCianAuthorized();

  const isTinyScreen = useIsTinyScreen();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    if (isMortgageRedirectEnabled) {
      cianAuthorizeAndRedirect();
    } else {
      authorizeAndRedirect({
        authorizationRequired,
        path,
        bankName,
        place,
        analyticEventKey,
        isMultiOffer,
      });
    }
  };

  return (
    <div className={cn(styles['btn'], styles[deviceType])}>
      <Button
        theme={theme}
        onClick={handleClick}
        fullWidth
        data-testid={ETestIds.OfferCardBtn}
        size={isTinyScreen ? 'XS' : 'M'}
      >
        {text}
      </Button>
    </div>
  );
};
